module.exports = __webpack_public_path__ + "static/media/home-banner.f123b389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bebanca/home-banner.png
// module id = 973
// module chunks = 0